// src/views/EditarUsuarioView.jsx
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUsuario, updateUsuario } from "../api"; // 👉 IMPORTANTE
import "./EditarUsuariosView.css";


export default function EditarUsuarioView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    nombre: "",
    email: "",
    dni: "",
    colegiado: "",
    rol: "psicologa",
    porcentaje_profesional: 70,
    password: "" // opcional
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [okMessage, setOkMessage] = useState("");

  // ------------------------------------------------------------
  // 🔍 CARGAR DATOS DEL USUARIO
  // ------------------------------------------------------------
  useEffect(() => {
    const loadUser = async () => {
      try {
        setError("");
        setLoading(true);

        const u = await getUsuario(id); // 🔥 MÉTODO DEL API

        setForm({
          nombre: u.nombre || "",
          email: u.email || "",
          dni: u.dni || "",
          colegiado: u.colegiado || "",
          rol: u.rol || "psicologa",
          porcentaje_profesional:
            u.porcentaje_profesional != null ? u.porcentaje_profesional : 70,
          password: ""
        });
      } catch (e) {
        console.error("Error cargando usuario:", e);
        setError(e.message || "No se pudo cargar el usuario");
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [id]);

  // ------------------------------------------------------------
  // ✏️ MANEJAR CAMBIOS DEL FORMULARIO
  // ------------------------------------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({
      ...f,
      [name]:
        name === "porcentaje_profesional" ? Number(value) : value
    }));
  };

  // ------------------------------------------------------------
  // 💾 GUARDAR CAMBIOS
  // ------------------------------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    setOkMessage("");

    try {
      await updateUsuario({
        id: Number(id),
        ...form,
      });

      setOkMessage("Usuario actualizado correctamente");
      // Si quieres volver automáticamente:
      // setTimeout(() => navigate("/admin/usuarios"), 1000);
    } catch (e) {
      console.error("Error actualizando usuario:", e);
      setError(e.message || "No se pudo actualizar el usuario");
    } finally {
      setSaving(false);
    }
  };

  // ------------------------------------------------------------
  // 🌀 LOADING
  // ------------------------------------------------------------
  if (loading) return <p>Cargando usuario...</p>;

  return (
    <div className="editar-usuario-container">
      <h2>Editar usuario #{id}</h2>

      {error && <div className="alert alert-error">{error}</div>}
      {okMessage && <div className="alert alert-success">{okMessage}</div>}

      <form onSubmit={handleSubmit} className="form-usuario">
        <div className="form-row">
          <label>Nombre</label>
          <input
            type="text"
            name="nombre"
            value={form.nombre}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-row">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-row">
          <label>DNI</label>
          <input
            type="text"
            name="dni"
            value={form.dni}
            onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <label>Colegiado</label>
          <input
            type="text"
            name="colegiado"
            value={form.colegiado}
            onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <label>Rol</label>
          <select
            name="rol"
            value={form.rol}
            onChange={handleChange}
            required
          >
            <option value="admin">Admin</option>
            <option value="psicologa">Psicóloga</option>
            <option value="psicologa-adultos">Psicóloga adultos</option>
            <option value="logopeda">Logopeda</option>
            <option value="nutricionista">Nutricionista</option>
          </select>
        </div>

        <div className="form-row">
          <label>Porcentaje profesional (%)</label>
          <input
            type="number"
            name="porcentaje_profesional"
            min="0"
            max="100"
            value={form.porcentaje_profesional}
            onChange={handleChange}
            required
          />
          <small>
            El centro recibirá:{" "}
            {100 - Number(form.porcentaje_profesional) || 0}%
          </small>
        </div>

        <div className="form-row">
          <label>Contraseña (dejar vacío para no cambiar)</label>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Nueva contraseña opcional"
          />
        </div>

        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate("/admin/usuarios")}
            className="btn-secondary"
          >
            Volver
          </button>
          <button type="submit" className="btn-primary" disabled={saving}>
            {saving ? "Guardando..." : "Guardar cambios"}
          </button>
        </div>
      </form>
    </div>
  );
}
